
import { useNavigate } from "react-router-dom";
import { LeadForm } from "@/components/leads/LeadForm";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

const LeadNew = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/leads');
  };

  const handleSuccess = () => {
    navigate('/leads');
  };

  const handleClose = () => {
    navigate('/leads');
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <Button variant="ghost" size="sm" onClick={handleBack}>
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back to Leads
        </Button>
        <h1 className="text-3xl font-bold tracking-tight">Create New Lead</h1>
      </div>
      
      <Card>
        <CardHeader>
          <CardTitle>Lead Information</CardTitle>
        </CardHeader>
        <CardContent>
          <LeadForm onClose={handleClose} onSuccess={handleSuccess} />
        </CardContent>
      </Card>
    </div>
  );
};

export default LeadNew;
